/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { ServiceObjectPartnerCreateV1Dto } from '../models/ServiceObjectPartnerCreateV1Dto';
import type { ServiceObjectPartnerPatchV1Dto } from '../models/ServiceObjectPartnerPatchV1Dto';
import type { ServiceObjectPartnerRelationsV1Dto } from '../models/ServiceObjectPartnerRelationsV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServiceObjectsPartnersService {
  /**
   * get all partner relations for an service object
   * @param objectId the id of the serviceObject
   * @returns ServiceObjectPartnerRelationsV1Dto a entity list
   * @throws ApiError
   */
  public static serviceObjectPartnerControllerV1FindAllV1(
    objectId: string,
  ): CancelablePromise<Array<ServiceObjectPartnerRelationsV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/service-objects/{objectId}/partner',
      path: {
        objectId: objectId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param objectId the id of the serviceObject
   * @param requestBody Service object partner relation fields to update
   * @returns ServiceObjectPartnerCreateV1Dto create entity
   * @throws ApiError
   */
  public static serviceObjectPartnerControllerV1CreateV1(
    objectId: string,
    requestBody: ServiceObjectPartnerCreateV1Dto,
  ): CancelablePromise<ServiceObjectPartnerCreateV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/service-objects/{objectId}/partner',
      path: {
        objectId: objectId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param objectId the id of the serviceObject
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static serviceObjectPartnerControllerV1RemoveManyV1(
    objectId: string,
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/service-objects/{objectId}/partner',
      path: {
        objectId: objectId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * get one partner relation for an service object
   * @param objectId the id of the serviceObject
   * @param id the id of the partner
   * @returns ServiceObjectPartnerRelationsV1Dto
   * @throws ApiError
   */
  public static serviceObjectPartnerControllerV1FindOneV1(
    objectId: string,
    id: string,
  ): CancelablePromise<ServiceObjectPartnerRelationsV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/service-objects/{objectId}/partner/{id}',
      path: {
        objectId: objectId,
        id: id,
      },
    });
  }
  /**
   * @param objectId the id of the serviceObject
   * @param id the id of the partner
   * @param requestBody Service object partner relation fields to update
   * @returns ServiceObjectPartnerRelationsV1Dto the update entity
   * @throws ApiError
   */
  public static serviceObjectPartnerControllerV1UpdatePartialV1(
    objectId: string,
    id: string,
    requestBody: ServiceObjectPartnerPatchV1Dto,
  ): CancelablePromise<ServiceObjectPartnerRelationsV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/service-objects/{objectId}/partner/{id}',
      path: {
        objectId: objectId,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param objectId the id of the serviceObject
   * @param id the id of the partner
   * @returns ServiceObjectPartnerRelationsV1Dto the entity
   * @throws ApiError
   */
  public static serviceObjectPartnerControllerV1RemoveOneV1(
    objectId: string,
    id: string,
  ): CancelablePromise<ServiceObjectPartnerRelationsV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/service-objects/{objectId}/partner/{id}',
      path: {
        objectId: objectId,
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
}
